import { TextField, InputAdornment } from "@mui/material";
import { WidgetProps } from "@rjsf/utils";
import { inputStyles, renderLabel, renderDescriptionTooltip } from "./common";

// Compact Text Input Widget - for shorter fields in form rows
export const ShortTextWidget = (props: WidgetProps) => {
  const { id, value, label, onChange, required, disabled, readonly, placeholder, schema, options } = props;

    const maxLength = (options?.maxLength || schema?.maxLength) as number | undefined;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const val = event.target.value;
    if (val === "") {
      onChange(undefined);
      return;
    }
    if (maxLength && val.length > maxLength) {
      return;
    }
    onChange(val);
  };

  return (
    <TextField
      id={id}
      fullWidth
      multiline
      value={value ?? ""}
      onChange={handleChange}
      disabled={disabled}
      slotProps={{
        input: {
          readOnly: readonly,
          endAdornment: schema.description ? (
            <InputAdornment position="end">
              {renderDescriptionTooltip(schema.description)}
            </InputAdornment>
          ) : null,
        },
      }}
      placeholder={placeholder}
      label={renderLabel(label, !!required)}
      required={required}
      size="small"
      variant="outlined"
      sx={inputStyles}
    />
  );
};
